import { createStore } from 'reflux';
import SaneStore from '../utils/sane-store-mixin';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import ZonesActions from '../actions/zones';
import SpeciesActions from '../actions/species';

let gs = null;
const colors = {
  'green': ['#eff8e9', '#a1c877', '#7ba251', '#5d8433', '#4d7423', '#2f5605'],

};

/**
 * [selectColorSchema description]
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
const selectColorSchema = name => {
  if (name.startsWith('primary')) {
    return colors.primary;
  } else if (name.startsWith('secondary')) {
    return colors.scondary;
  } else if ((name.startsWith('presc'))) {
    return colors.preschool;
  } else {
    return colors.green;
  }
};
/**
 * [getColor description]
 * @param  {[type]} value [description]
 * @param  {[type]} name  [description]
 * @return {[type]}       [description]
 */
const getColor = value => {
  return selectColorSchema('green')[gs.getClass(value)];
};

const setStyle = (features, species) => {
  const values = [];
  const zones = [];

  forEach(features.features, function(item) {
    values.push(parseFloat(item.properties.coverage));
    zones.push(item.properties.zone);
  });

  gs = new geostats(values);
  const jenks = gs.getClassJenks(4);

  if (features) {
    forEach(features.features, function(feature) {
      const speciesdata = species.filter(function(item) {
        return item.Zones.toUpperCase() === feature.properties.zone.toUpperCase();
      });

      let index;
      const found = find(zones, function(item, key) {
        index = key;
        return (item.toUpperCase() === feature.properties.zone.toUpperCase());
      });

      let speciestext = '';
      forEach(speciesdata, function(s) {
        speciestext = `${speciestext} <b>SPECIE:</b> ${s.Species} <br> <b>DESCRIPTION:</b> ${s.Description} <hr></hr>`;
      });

      if (found && speciesdata) {
        const color = getColor(values[index]);
        feature.style = {
          weight: 2,
          opacity: 0.5,
          color: 'white',
          fillOpacity: 1,
          fillColor: color};
        feature.properties.popupContent = `<h3> ZONE: ${feature.properties.zone} </h3>
          <hr></hr>
          ${speciestext}
          <b> TOTAL FOREST COVER: ${feature.properties.coverage} %</b>`;
      } else {
        feature.style = {
          weight: 2,
          opacity: 0.5,
          color: 'white',
          dashArray: '3',
          fillOpacity: 0,
          fillColor: '#7a859c'};
        //console.log(feature.properties.COUNTY + ' not found');
      }
    });
    features.jenks = jenks;
    features.colors = selectColorSchema('green');
  }
  //debugger;
  return features;
};
const ZonesStore = createStore({
  initialData: [],
  mixins: [SaneStore],
  listenables: [ZonesActions, SpeciesActions],
  init() {
    this.listenTo(ZonesActions.loadZonesCompleted, 'loadData');
    this.listenTo(SpeciesActions.loadCompleted, 'updateLayer');
  },
  loadData(data) {
    this.setData(data);
    SpeciesActions.loadSpecies();
  },

  updateLayer(species = this.species) {
    if (species) {
      this.species = species;
    }
    if (this.data) {
      const processed = setStyle(this.data, this.species);
      /* Force map to remove the initial layer*/
      this.setData({zones: null});
      this.setData({zones: processed});
    }

  },
});


export default ZonesStore;



/** WEBPACK FOOTER **
 ** ./app/scripts/stores/zones.es6
 **/